import { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name SyHubDocs 文档与案例管理平台默认配置
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 品牌蓝
  colorPrimary: '#1677ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'SyHubDocs',
  pwa: false,
  logo: '/logo.svg',
  iconfontUrl: '',
  // 注意：菜单折叠状态现在由 app.tsx 中的 localStorage 管理
  // 不在这里设置 defaultCollapsed，避免冲突
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
